import { isFeatureActive } from '@helpers';
import PaletteFavoriteButton from 'palette/ProductCard/ProductCardBlocks/FavoriteButton';
import useFavorites from '@common/Favorites/hooks/useFavorites';
import { useConfig } from '@common/Hooks/useConfig';
import { useTranslation } from '@common/Hooks/useTranslation';
import { GA_FAVORITES_ACTIONS, GA_FAVORITES_CATEGORY } from '@common/Tracking';
import { pushGAEventToDataLayer } from '@helpers/dataLayer';

export function FavoriteButton({
    className,
    variantId,
    trackingValue,
    iconSize,
    isTransparent = false,
    itemsParameters = {},
    interactionOrigin
}) {
    const translate = useTranslation();
    const config = useConfig();
    const { isFavorite, addToFavorites, removeFromFavorites } = useFavorites();

    const toggleFavoritesHandler = () => {
        let eventAction = '';

        if (isFavorite(variantId)) {
            removeFromFavorites(variantId);
            eventAction = GA_FAVORITES_ACTIONS.removeFromFavorites;
        } else {
            addToFavorites(variantId, itemsParameters, interactionOrigin);
            eventAction = GA_FAVORITES_ACTIONS.addToFavorite;
        }

        if (trackingValue) {
            pushGAEventToDataLayer(GA_FAVORITES_CATEGORY, eventAction, trackingValue);
        }
    };

    if (!isFeatureActive('product.detail.favorites', config)) {
        return null;
    }

    return (
        <PaletteFavoriteButton
            ariaLabel={translate('product.details.add_to_favorites.button')}
            className={className}
            isSelected={isFavorite(variantId)}
            isTransparent={isTransparent}
            size={iconSize}
            onClick={toggleFavoritesHandler}
        />
    );
}
